// src/data/personal.js
export const personal = {
  name: "Rishanth Rajendhran",
  phonetic: "riː-ʃɑːnθ",
  authorInTamil: "ரிஷாந்த் ராஜேந்திரன்",
  location: "College Park, Maryland, US",
  hometown: "Chennai, Tamil Nadu, India",
  email: "pearls_lucid0a@icloud.com",
  twitter: "https://x.com/rishanthrajendh",
  linkedin: "https://linkedin.com/in/rishanth-r-11b436191",
  github: "https://github.com/RishanthRajendhran",
  avatar: "/avatar.jpg",
  credo: "Nothing worth having comes easy",
  credoInTamil: "நல்லதே நடக்கட்டும்",
  affiliations: [
    { name: "IIT Madras",         link: "https://www.iitm.ac.in",         logo: "/aff_iitm.png"   },
    { name: "University of Utah", link: "https://www.utah.edu",           logo: "/aff_utah.png"   },
    { name: "UMass Amherst",      link: "https://www.umass.edu",         logo: "/aff_umass.png"  },
    { name: "UMD",                link: "https://www.umd.edu",           logo: "/aff_umd.png"    },
  ]
};